// @ts-nocheck
/* eslint-disable */
import { CONFIG, _, Scene, store } from "~/route/globals";
import { createGeometry } from "./geometry";
import SummaryMarkers from "./markers-summary";
import MapInteractiveGeometry from "~/interactiveGeometry";
import { MapContextItem } from "~/route/map/context-item";
import M3D from "~/route/map/m3d";
import { ROUTE_CONST } from "~/route/const";
import { getPOI } from "~/route/utils";
import { MAP_OVERLAYS } from "~/state/map/constants";
import { watch, watchMap } from "~/state/util";
import { Unsubscribe } from "redux";
import { setCoordinates } from "~/state/map/state";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import WasmStoreGeometry from "~/wasm/store/wasm-store-geometry";
import { WASM_ZINDEX } from "~/wasm/const";

/**
 * Obal pro:
 * - vizualizace nad mapou
 */
const DEACTIVE = 0;
const ACTIVE = 1;

export default class Map {
	_interactive: MapInteractiveGeometry;

	_storeMapUnsubscribe: Unsubscribe;

	_wasmMarkers: Array<WasmStoreMarker>;

	_wasmGeometries: Array<Array<WasmStoreGeometry>>;

	_wasmTrafficGeometries: Array<{ geoms: Array<WasmStoreGeometry>; }>;

	_wasmPointMarkers: Array<WasmStoreMarker>;

	_showAlternatives: boolean;

	_summaryMarkers: SummaryMarkers;

	constructor() {
		this._markerLayer = null;
		this._geomLayer = null;
		this._activeGeomLayer = null;
		this._hoverGeomLayer = null;
		this._pointLayer = null;
		this._closureLayer = null;
		this._showAlternatives = true;
		this._mCListeners = [];
		this._ss = [];
		this._spch = [];
		this._markers = [];
		this._lids = [];
		this._geometry = [];
		this._trafficGeom = [];
		this._closuresGeom = [];
		this._closureMarkers = [];
		this._msl = [];
		this._points = [];
		this._interactive = new MapInteractiveGeometry(this, {
			fromRoute: true,
		});
		this._summaryMarkers = new SummaryMarkers(this);
		this._m3d = new M3D(this);
		this._showPUBTMidPointCard = null;
		this._wasmMarkers = [];
		this._wasmGeometries = [];
		this._wasmPointMarkers = [];
		this._wasmTrafficGeometries = [];

		this._build();
		this._setListeners();

		// pri zmene viditelne vrstve panoramat vypiname interaktivitu geometrie
		const wt = watch(store.getState, "map", watchMap);

		this._storeMapUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			const oldPanorama = oldMap ? oldMap.mapset in oldMap.currentOverlays && oldMap.currentOverlays[oldMap.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1 : false;
			const newPanorama = newMap.mapset in newMap.currentOverlays && newMap.currentOverlays[newMap.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

			if (Mapy.getComponent("route").isActive() && !Mapy.getComponent("distanceMeter").isActive() && !Mapy.getComponent("userMarks").isActive()) {
				if (oldPanorama !== newPanorama) {
					this._interactive.enabled = !newPanorama;
				}
			}
		}));
	}

	destroy() {
		this._storeMapUnsubscribe();
		this._interactive.destroy();
		Scene.removeListeners(this._ss);
		Scene.removeListeners(this._spch);
		Scene.removeListeners(this._mCListeners);
		Mapy.CML.removeListeners(this._lids);
		this._markerLayer.disable();
		Scene.removeLayer(this._markerLayer);
		this._summaryMarkers.layer.disable();
		Scene.removeLayer(this._summaryMarkers.layer);
		this._summaryMarkers.wasmMarkersVisibility(false);
		this._geomLayer.disable();
		Scene.removeLayer(this._geomLayer);
		this._activeGeomLayer.disable();
		Scene.removeLayer(this._activeGeomLayer);
		this._hoverGeomLayer.disable();
		Scene.removeLayer(this._hoverGeomLayer);
		this._m3d.destroy();
		Scene.removeLayer(this._pointLayer);
		this._pointLayer.disable();
		Scene.removeLayer(this._closureLayer);
		this._closureLayer.disable();

		this._showPUBTMidPointCard = null;

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.destroy();
		}

		for (const wasmGeometries of this._wasmGeometries) {
			for (const wasmGeometry of wasmGeometries) {
				wasmGeometry.destroy();
			}
		}

		for (const wasmMarker of this._wasmPointMarkers) {
			wasmMarker.destroy();
		}

		for (const wasmGeometryItem of this._wasmTrafficGeometries) {
			for (const wasmGeometry of wasmGeometryItem.geoms) {
				wasmGeometry.destroy();
			}
		}
	}

	get markerLayer() {
		return this._markerLayer;
	}

	get geomLayer() {
		return this._geomLayer;
	}

	get activeGeomLayer() {
		return this._activeGeomLayer;
	}

	get hoverGeomLayer() {
		return this._hoverGeomLayer;
	}

	get pointLayer() {
		return this._pointLayer;
	}

	get closureLayer() {
		return this._closureLayer;
	}

	get interactive() {
		return this._interactive;
	}

	get markers() {
		return this._markers;
	}

	set showAlternatives(show) {
		this._showAlternatives = show;
		this._summaryMarkers.showAlternatives = show;

		if (show) {
			this.hideGeom();
			this.showGeom(true);

			if (Scene.isM3dActive()) {
				this._m3d.show(this._interactive.allCoords)
			}
		} else {
			if (this._geomLayer) {
				this._geomLayer.disable()
				Scene.removeLayer(this._geomLayer);
			}

			if (this._hoverGeomLayer) {
				this._hoverGeomLayer.disable()
				Scene.removeLayer(this._hoverGeomLayer);
			}

			if (Scene.isM3dActive()) {
				this._m3d.show([this._interactive.allCoords[Mapy.CML.state.route.index]])
			}

			this._wasmShowAlternatives();
		}
	}

	_wasmShowAlternatives(routeIndex: number = Mapy.CML.state.route.index) {
		if (CONFIG.wasmEnabled) {
			const curRouteInd = routeIndex;

			// wasm
			for (let ind = 0, max = this._wasmGeometries.length; ind < max; ind++) {
				const wasmGeometryItem = this._wasmGeometries[ind];

				for (const wasmGeometry of wasmGeometryItem) {
					wasmGeometry.update({
						visible: curRouteInd === ind || this._showAlternatives,
					});
				}
			}

			for (let ind = 0, max = this._wasmTrafficGeometries.length; ind < max; ind++) {
				const wasmGeometryItem = this._wasmTrafficGeometries[ind];

				for (const wasmGeometry of wasmGeometryItem.geoms) {
					wasmGeometry.update({
						visible: curRouteInd === ind || this._showAlternatives,
					});
				}
			}
		}
	}

	active() {
		this.showGeom();

		Scene.addLayer(this._summaryMarkers.layer).enable();
		this._summaryMarkers.activate();

		if (!CONFIG.inFrame) {
			const mapState = store.getState().map;
			const panorama = mapState.mapset in mapState.currentOverlays && mapState.currentOverlays[mapState.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

			if (!panorama) {
				this._interactive.enabled = true;
			}
		}

		this._toggleClosureMarkers();

		let items = Mapy.CML.state.route.items;
		if (items.length) {
			this._activeMarkers(true);
		}
	}

	deactive() {
		this._summaryMarkers.layer.disable();
		Scene.removeLayer(this._summaryMarkers.layer);
		this._summaryMarkers.deactivate();

		this.hideGeom();

		this._toggleClosureMarkers(true);

		if (this._interactive) {
			this._interactive.enabled = false;
		}

		let items = Mapy.CML.state.route.items;

		if (items.length) {
			this._activeMarkers(false);
		}
	}

	/**
	 * zobrazit geometrie i mimo aktivni stav
	 * @param  {boolean} closure zobrazeni uzavirek
	 */
	showGeom(closure) {
		if (this._markerLayer) {
			Scene.addLayer(this._markerLayer).enable();
		}

		if (this._geomLayer && this._showAlternatives) {
			Scene.addLayer(this._geomLayer).enable();
		}

		if (this._activeGeomLayer) {
			Scene.addLayer(this._activeGeomLayer).enable();
		}

		if (this._hoverGeomLayer && this._showAlternatives) {
			Scene.addLayer(this._hoverGeomLayer).enable();
		}

		if (this._closureLayer) {
			Scene.addLayer(this._closureLayer).enable();
		}

		if (this._pointLayer) {
			Scene.addLayer(this._pointLayer).enable();
		}

		if (closure) {
			if (this._closureMarkers.length) {
				let cms = this._closureMarkers[Mapy.CML.state.route.index] || [];

				for (let num = 0; num < cms.length; num++) {
					this._closureLayer.addMarker(cms[num].marker);
					cms[num].wasmMarker.update({
						visible: true,
					});
				}
			}
		}

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.update({
				visible: true,
			});
		}

		for (const wasmMarker of this._wasmPointMarkers) {
			wasmMarker.update({
				visible: true,
			});
		}

		this._wasmShowAlternatives();
	}

	hideGeom() {
		if (this._markerLayer) {
			this._markerLayer.disable()
			Scene.removeLayer(this._markerLayer);
		}

		if (this._geomLayer) {
			this._geomLayer.disable()
			Scene.removeLayer(this._geomLayer);
		}

		if (this._activeGeomLayer) {
			this._activeGeomLayer.disable()
			Scene.removeLayer(this._activeGeomLayer);
		}

		if (this._hoverGeomLayer) {
			this._hoverGeomLayer.disable()
			Scene.removeLayer(this._hoverGeomLayer);
		}

		if (this._pointLayer) {
			this._pointLayer.disable();
			Scene.removeLayer(this._pointLayer);
		}

		if (this._closureLayer) {
			this._closureLayer.disable();
			Scene.removeLayer(this._closureLayer);
		}

		if (this._closureMarkers.length) {
			for (let i = 0; i < this._closureMarkers.length; i++) {
				let cms = this._closureMarkers[i];

				for (let num = 0; num < cms.length; num++) {
					this._closureLayer.removeMarker(cms[num].marker);
					cms[num].wasmMarker.update({
						visible: false,
					});
				}
			}
		}

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.update({
				visible: false,
			});
		}

		for (const wasmGeometries of this._wasmGeometries) {
			for (const wasmGeometry of wasmGeometries) {
				wasmGeometry.update({
					visible: false,
				});
			}
		}

		for (const wasmMarker of this._wasmPointMarkers) {
			wasmMarker.update({
				visible: false,
			});
		}

		for (const wasmGeometryItem of this._wasmTrafficGeometries) {
			for (const wasmGeometry of wasmGeometryItem.geoms) {
				wasmGeometry.update({
					visible: false,
				});
			}
		}
	}

	handleEvent(e) {
		if (CONFIG.inFrame) {
			this._openOnMap();
		}
	}

	_build() {
		this._markerLayer = Scene.createLayerMarker("route-markers");
		this._geomLayer = Scene.createLayerGeometry("route-geometry-items", { mouseReactExtension: 8 });
		this._activeGeomLayer =  Scene.createLayerGeometry("route-active-geometry-items", { mouseReactExtension: 8 });
		this._hoverGeomLayer = Scene.createLayerGeometry("route-hover-geometry-items", { mouseReactExtension: 8 });
		this._pointLayer = Scene.createLayerGeometry("route-point-items");
		this._closureLayer = Scene.createLayerMarker("route-closure-markers");
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		// state listenery
		this._lids.push(Mapy.CML.addListener((items, state) => {
			// markery
			const isReadOnly = state.route.readOnly;
			this._interactive.enabled = true;
			this._interactive.markerDad = !isReadOnly;

			this._makeMarkers(items, state.route.request || isReadOnly, state.route.request);

			if (items.length) {
				this.showGeom();
				!state.route.interaction && this._setInteraction(false);
			}
		}, "route.items"));

		this._lids.push(Mapy.CML.addListener((responseData, state) => {
			if (responseData.length) {
				// geometrie
				this._makeGeometry(state.route.items, state);

				// zoomovani
				this._zoom(state.route);

				!state.route.interaction && this._setInteraction(false);
			}
			else {
				this._clearGeometry(state);
			}
		}, "route.responseData"));

		this._lids.push(Mapy.CML.addListener((editItems, state) => {
			if (editItems) {
				this._makeMarkers(editItems, true);
			}
			else {
				this._makeMarkers(state.route.items, state.route.readOnly);
			}
		}, "route.editItems"));

		this._lids.push(Mapy.CML.addListener((hoverInd, state) => {
			if (!state.route.active) {
				return;
			}

			this._markers.forEach((i, ind) => {
				i.setActive(hoverInd == -1 ? true : hoverInd == ind);
			});

			let ind = 0;

			for (const wasmMarker of this._wasmMarkers) {
				const isActive = hoverInd === -1 || ind === hoverInd;

				wasmMarker.update({
					bringToTheFront: isActive,
					visual: isActive
						? "standard"
						: "inactive",
				});
				ind++;
			}
		}, "route.hoverInd"));

		this._lids.push(Mapy.CML.addListener(interaction => {
			this._setInteraction(interaction);
		}, "route.interaction"));

		this._lids.push(Mapy.CML.addListener((index, state) => {
			this._setActive(state.route);
		}, "route.index"));

		this._lids.push(Mapy.CML.addListener((hover, state) => {
			this._closureMarkers[state.route.index].forEach(cm => {
				cm.marker.getContainer(el => {
					el.classList[hover ? "add" : "remove"]("hover");
				});
				// cm.wasmMarker hover? todor
			});
		}, "route.closureHover"));

		this._lids.push(Mapy.CML.addListener((request, state) => {
			/*if (request) {
				this.showGeom();
			}*/
			if (request) {
				this._clearGeometry(state);
			}
			else {
				// geometrie
				this._makeGeometry(state.route.items, state);

				this._makeMarkers(state.route.items, state.route.readOnly);

				// zoomovani
				this._zoom(state.route);

				!state.route.interaction && this._setInteraction(false);
			}
		}, "route.request"));

		this._lids.push(Mapy.CML.addListener((error, state) => {
			if (error != "") {
				this._clearGeometry(state);
			}
		}, "route.error"));

		this._lids.push(Mapy.CML.addListener((hoverIndex, state) => {
			if (this._geometry.length && this._geometry[0].length && state.route.items.length == 2) {
				this._hoverGeometry(hoverIndex);
			}
		}, "route.hoverIndex"));

		// prisel traffic, tak ho vizualizujeme
		this._lids.push(Mapy.CML.addListener((trafficLoaded, state) => {
			if (!trafficLoaded) { return; }

			this._makeGeometry(state.route.items, state);
		}, "route.trafficLoaded"));

		this._lids.push(Mapy.CML.addListener((data, satte) => {
			if (state.route.active) {
				if (data && data.data.type === "midpoint") {
					const marker = this._markers[data.itemIndex];

					marker.setPopupCallback(card => {
						card.getContainer().classList.add("wait");
						card.getBody().innerHTML = data.elm;
					});

					marker.setCardOptions({
						showTimeout: 0,
						hideTimeout: 10,
					});

					this._showPUBTMidPointCard = marker;
					marker.showCard();
				} else if (this._showPUBTMidPointCard) {
					this._showPUBTMidPointCard.setPopupCallback(undefined);
					this._showPUBTMidPointCard.clearCard();

					this._showPUBTMidPointCard = null;
				}
			}
		}, "route.pubtv3ShowSectionMarker")),

		// scene listenery
		this._ss.push(Scene.addListener("marker-enter", "_markerEnter", this));
		this._ss.push(Scene.addListener("marker-leave", "_markerLeave", this));
		this._spch.push(Scene.addListener("provider-changed", (data) => { // po prepnuti z 3d musi dojit k znovu nastaveni geometrii do vrstvy
			if (data.data.name == "map") {
				let state = Mapy.CML.state;
				this._makeGeometry(state.route.items, state);
			}
			else {
				this._m3d.show(this._showAlternatives ? this._interactive.allCoords : [this._interactive.allCoords[Mapy.CML.state.route.index]]);
			}
		}));

	}

	/**
	 * Vytvoreni geometrii ze stavu.
	 *
	 * @param   {Array}  items
	 * @param   {Object}  state
	 */
	_makeGeometry(items, state) {
		for (const wasmGeometries of this._wasmGeometries) {
			for (const wasmGeometry of wasmGeometries) {
				wasmGeometry.destroy();
			}
		}

		for (const wasmMarker of this._wasmPointMarkers) {
			wasmMarker.destroy();
		}

		for (const wasmGeometryItem of this._wasmTrafficGeometries) {
			for (const wasmGeometry of wasmGeometryItem.geoms) {
				wasmGeometry.destroy();
			}
		}

		for (const closureMarkerItems of this._closureMarkers) {
			for (const closureMarkerItem of closureMarkerItems) {
				closureMarkerItem.wasmMarker.destroy();
			}
		}

		this._wasmGeometries.length = 0;
		this._wasmPointMarkers.length = 0;
		this._wasmTrafficGeometries.length = 0;
		this._closureMarkers.length = 0;

		let geometry = createGeometry({
			state,
			map: this,
			geometry: this._geometry,
			trafficGeom: this._trafficGeom,
			closuresGeom: this._closuresGeom,
			points: this._point,
		});

		this._geometry = geometry.geometry;
		this._trafficGeom = geometry.trafficGeom;
		this._closuresGeom = geometry.closuresGeom;
		this._points = geometry.points;
		this._closureMarkers = geometry.closureMarkers;
		this._wasmGeometries = geometry.wasmGeometries;
		this._wasmPointMarkers = geometry.wasmPointsMarkers;
		this._wasmTrafficGeometries = geometry.wasmTrafficGeometries;

		if (this._closureMarkers.length) {
			if (!this._mCListeners.length) {
				this._mCListeners.push(Scene.addListener("marker-click", "_markerClick", this));
			}
		}
		else {
			if (this._mCListeners.length) {
				Scene.removeListeners(this._mCListener);
				this._mCListeners = [];
			}
		}

		this._wasmShowAlternatives(state.route.index);
		this._setActive(state.route);

		if (!CONFIG.inFrame && state.route.interaction) {
			const mapState = store.getState().map;
			const panorama = mapState.mapset in mapState.currentOverlays && mapState.currentOverlays[mapState.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

			if (!panorama) {
				this._interactive.enabled = true;
			}
		}
	}

	/**
	 * Vytvoreni markeru ze stavu.
	 *
	 * @param   {Array}  items
	 * @param   {Boolean}  disableDAD  Zruseni DAD?
	 * @param   {Boolean}  disable  Neaktivni a sede markery
	 */
	_makeMarkers(items, disableDAD, disabled) {
		while (this._markers.length) {
			let m = this._markers.pop();
			m.setDrag(false);
			m.setFocus(false);
			m.destroy();
		}

		if (this._msl.length) {
			Scene.removeListeners(this._msl);
			this._msl = [];
		}

		this._markerLayer.removeAll();

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.destroy();
		}

		this._wasmMarkers.length = 0;

		// markery
		let oneEndItem =  items.length == 1 && items[0].position == ROUTE_CONST.position.end;
		let len = items.length;
		let markers = [];
		const routeState = Mapy.CML.state.route;

		for (let ind = 0; ind < items.length; ind++) {
			let i = items[ind];

			if (!i.geometry) return;

			let type;
			let elm;
			let m3dValue = "";
			let wasmMarker: WasmStoreMarker = null;
			const markerCoords = Scene.stringToCoords(i.geometry)[0];

			if (!ind && !oneEndItem) {
				type = Scene.VISUAL.MARKER_WINDY.BIG;
				elm = Mapy.Util.node("span", { innerHTML: _("route.form.start"), className: "text" });
				m3dValue = "start";
				wasmMarker = new WasmStoreMarker({
					type: "route-start",
					visual: disabled
						? "inactive"
						: "standard",
					lon: markerCoords.x,
					lat: markerCoords.y,
					zIndex: WASM_ZINDEX.marker.routeStart,
					customData: {
						order: ind + 1,
						route: {},
					},
					draggable: !disableDAD && !disabled && !CONFIG.inFrame,
					interactionType: "click-hover",
				});
			}
			else if (ind == len - 1 || oneEndItem) {
				type = Scene.VISUAL.MARKER_WINDY.BIG;
				elm = Mapy.Util.node("span", { innerHTML: _("route.form.end"), className: "text" });
				m3dValue = "end";
				wasmMarker = new WasmStoreMarker({
					type: "route-end",
					visual: disabled
						? "inactive"
						: "standard",
					lon: markerCoords.x,
					lat: markerCoords.y,
					zIndex: WASM_ZINDEX.marker.routeEnd,
					customData: {
						order: ind + 1,
						route: {},
					},
					draggable: !disableDAD && !disabled && !CONFIG.inFrame,
					interactionType: "click-hover",
				});
			}
			else {
				type = Scene.VISUAL.MARKER_WINDY.SMALL;
				elm = Mapy.Util.node("span", { innerHTML: ind + 1, className: "text" });
				m3dValue = "waypoint";
				wasmMarker = new WasmStoreMarker({
					type: "user-marks",
					visual: disabled
						? "inactive"
						: "standard",
					lon: markerCoords.x,
					lat: markerCoords.y,
					zIndex: WASM_ZINDEX.marker.routeWaypoint,
					customData: {
						order: ind + 1,
						route: {},
					},
					draggable: !disableDAD && !disabled && !CONFIG.inFrame,
					interactionType: "click-hover",
				});
			}

			let marker = Scene.createMarkerWindy(markerCoords, null, {
				type,
				elm,
				m3dData: {
					type: "route",
					value: m3dValue
				}
			});

			marker.setActive(!disabled);
			marker.setFocus(!disabled);

			this._wasmMarkers.push(wasmMarker);

			if (!disabled && !CONFIG.inFrame) {
				marker.getContainer(el => {
					el.addEventListener("pointerup", e => {
						if (e.pointerType == "mouse" && (e.which == 3 || e.button == 2)) {
							this._setContextMenu(e, ind);
						}
					});
				});

				this._msl.push(Scene.addListener("marker-enter", data => {
					if (Mapy.getComponent("route").isActive()) {
						this._interactive.enabled = false;
					}
				}, this, marker));

				this._msl.push(Scene.addListener("marker-leave", data => {
					if (Mapy.getComponent("route").isActive() && !CONFIG.inFrame) {
						const mapState = store.getState().map;
						const panorama = mapState.mapset in mapState.currentOverlays && mapState.currentOverlays[mapState.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

						if (!panorama) {
							this._interactive.enabled = true;
						}
					}
				}, this, marker));
			}

			if (!disableDAD) {
				let actualId = -1;

				this._msl.push(Scene.addListener("marker-drag-start", () => {
					let id = Date.now();

					if (routeState.loading) {
						Mapy.CML.state = {
							route: {
								loading: false
							}
						};
					}
					let dragStop = data => {
						// nacitame -> nebudeme menit polohu
						if (Mapy.CML.state.route.request) {
							actualId = -1;
							Scene.removeListeners([stopDragListener]);
							return;
						}

						let coords = data.data.coords;

						Mapy.CML.state = {
							route: {
								loading: true
							}
						};

						getPOI(coords).then(data => {
							let items = Mapy.CML.state.route.items;

							if (!items[ind]) return;

							if (actualId == id) {
								actualId = -1;
							}
							else {
								return;
							}

							Object.assign(items[ind], {
								usertitle: "",
								favoriteId: "",
							}, data);
							Mapy.CML.state = {
								route: {
									items,
									loading: false
								}
							};
							Mapy.getComponent("history").save();
							Scene.removeListeners([stopDragListener]);
						}, () => {});
					};

					actualId = id;

					let stopDragListener = Scene.addListener("marker-drag-stop", dragStop, this, marker);
				}, this, marker));
				if (!CONFIG.inFrame) {
					marker.decorateDraggable();
				}
			}

			markers.push(marker);
		}

		// waypointy pro vylet
		if (len == 1 && items[0].tripData && items[0].tripData[routeState.index] && !items[0].tripData[routeState.index].triplist) {
			let coords = Scene.stringToCoords(items[0].tripData[routeState.index].waypoints);

			// vlozime waypointy
			for (let ind = 1; ind < coords.length; ind++) {
				let c = coords[ind];

				if (!c) continue;

				let marker = Scene.createMarkerWindy(c, null, {
					type: Scene.VISUAL.MARKER_WINDY.SMALL
				});

				if (!disableDAD) {
					Scene.addListener("marker-drag-stop", data => {
						// nacitame -> nebudeme menit polohu
						if (Mapy.CML.state.route.loading) return;

						let c = data.data.coords;

						coords.splice(ind, 1, c);

						Mapy.CML.state = {
							route: {
								params: {
									waypoints: Scene.coordsToString(coords)
								}
							}
						};
					}, this, marker);

					marker.decorateDraggable();
				}

				const wasmMarker = new WasmStoreMarker({
					type: "small",
					lon: c.x,
					lat: c.y,
					zIndex: WASM_ZINDEX.marker.routeTripWaypoint,
					customData: {
						order: ind + 1,
						route: {
							isTripWaypoint: true,
						},
					},
					draggable: !disableDAD,
					interactionType: disableDAD ? "none" : "click-hover",
				});

				markers.push(marker);
				this._wasmMarkers.push(wasmMarker);
			}
		}

		if (CONFIG.inFrame && len) {
			if (this._mcL) {
				Scene.removeListeners(this._mcL);
			}

			this._mcL = [];
			this._mcL.push(Scene.addListener("marker-click", "_openOnMap", this));
		}


		this._markers = markers;
		this._markerLayer.addMarker(markers);
	}

	/**
	 * Najeti na marker mysi.
	 *
	 * @param   {Event}  e
	 */
	_markerEnter(e) {
		if (this._showPUBTMidPointCard) { return; }
		let ind = this._markers.indexOf(e.target);

		if (ind != -1) {
			Mapy.CML.state = {
				route: {
					hoverInd: ind
				}
			};
		}
	}

	/**
	 * Odjeti z markeru mysi.
	 *
	 * @param   {Event}  e
	 */
	_markerLeave(e) {
		let ind = this._markers.indexOf(e.target);

		if (ind != -1) {
			Mapy.CML.state = {
				route: {
					hoverInd: -1
				}
			};
		}
	}

	/**
	 * Klik na marker.
	 *
	 * @param   {Event}  e
	 */
	_markerClick(e) {
		if (this._closureMarkers.length) {
			let cl = (this._closureMarkers[Mapy.CML.state.route.index] || []).filter(cm => {
				return cm.marker == e.target;
			});

			if (cl.length) {
				let c = cl[0];

				if (c.id && c.id != "" && c.source && c.source != "") {
					Mapy.getComponent("detail").setState({
						source: c.source,
						id: c.id
					});

					Mapy.getComponent("history").save();
				}
				else if (c.geom) {
					const coords = c.marker.getCoords();

					Mapy.getComponent("detail").setState({
						source: "closure",
						id: coords.toWGS84().join(","),
						title: c.title,
						description: c.description,
						coords
					});

					Mapy.getComponent("history").save();
				}
			}
		}
	}

	/**
	 * Nastaveni interakce mapy.
	 *
	 * @param   {Boolean}  state
	 */
	_setInteraction(state) {
		if (!CONFIG.inFrame) {
			const mapState = store.getState().map;
			const panorama = mapState.mapset in mapState.currentOverlays && mapState.currentOverlays[mapState.mapset].indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

			if (!state || !panorama) {
				this._interactive.enabled = state;

				for (let i = 0; i < this._markers.length; i++) {
					let marker = this._markers[i];
					marker.getContainer(el => {
						el.classList[state ? "remove" : "add"]("disable-interaction");
					});
					marker.setActive(state);
					marker.setDrag(state);
				}
			}
		}
	}

	async _setContextMenu(e, ind) {
		e.preventDefault();
		e.stopPropagation();

		let menu = Scene.fillContextMenu();

		for (let i = 0; i < 2; i++) {
			let items = menu.getItems();
			menu.removeItem(items[0]);
		}

		this._menuItem = new MapContextItem(ind);
		await menu.addItem(this._menuItem, 0);
		menu.open(e);
	}

	_zoom(routeState) {
		let coords = this._interactive.allCoords;

		if (routeState.zoom && coords[routeState.index] && coords[routeState.index].length >= 2) {
			let cz = Scene.computeCenterZoom(coords[routeState.index], true);
			let polyLine = Scene.createGeometrySmart(Scene.GEOMETRY.POLYLINE, null, coords[routeState.index]);
			let bbox = polyLine.getBBox();

			// pokud je geometrie v pruhledu pri odebirani, nezoomujeme || pokud se jedna o editaci ci pridani vyletu || pokud se pridava bod, ktery neni ve vyrezu mapy
			if (!this._geometryInView(polyLine) || routeState.forceZoom || (bbox.width < 100 && bbox.height < 100)) {
				const [longitude, latitude] = cz[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: cz[1],
					animate: true,
				}));
			}
		}
	}

	// vypocet, zda je cest geometrie jeste v pruhledu
	_geometryInView(polyline) {
		let pixels = polyline.getPixels();
		let size = Scene.getSize();
		let mp = {
			topLeft: [0 - size.x / 2, 0 - size.y / 2],
			bottomRight: [size.x / 2, size.y / 2]
		}

		for (let i = 0; i < pixels.length; i++) {
			let p = pixels[i];
			if (p.x > mp.topLeft[0] && p.x < mp.bottomRight[0] && p.y > mp.topLeft[1] && p.y < mp.bottomRight[1]) {
				return true;
			}
		}

		return false;
	}

	_setActive(routeState) {
		if (routeState.items.length == 2 && routeState.params.type != ROUTE_CONST.TYPE_PUBT) {
			for (let i = 0; i < this._geometry.length; i++) {
				this._geometry[i].forEach(g => {
					this._changeStyle(g, i != routeState.index ? DEACTIVE : ACTIVE);
				});

				if (this._closuresGeom[i]) {
					this._closuresGeom[i].forEach(cg => {
						this._changeStyle(cg, i != routeState.index ? DEACTIVE : ACTIVE, "closure");
					});
				}

				if (this._trafficGeom[i]) {
					this._trafficGeom[i].forEach(cg => {
						this._changeStyle(cg, i != routeState.index ? DEACTIVE : ACTIVE, "traffic");
					});
				}
			}

			this._toggleClosureMarkers();

			// wasm
			for (let ind = 0, max = this._wasmGeometries.length; ind < max; ind++) {
				const wasmGeometries = this._wasmGeometries[ind];
				const isActive = ind === routeState.index;

				for (const wasmGeometry of wasmGeometries) {
					wasmGeometry.update({
						visual: isActive ? "standard" : "inactive",
						bringToTheFront: isActive,
						customData: {
							...wasmGeometry.data?.customData ? wasmGeometry.data.customData : {},
							route: {
								...wasmGeometry.data?.customData?.route ? wasmGeometry.data.customData.route : {},
								routeIndex: ind,
							},
						},
					});
				}
			}

			for (let ind = 0, max = this._wasmTrafficGeometries.length; ind < max; ind++) {
				const wasmGeometryItem = this._wasmTrafficGeometries[ind];
				const isActive = ind === routeState.index;

				for (const wasmGeometry of wasmGeometryItem.geoms) {
					wasmGeometry.update({
						visual: isActive ? "standard" : "inactive",
						bringToTheFront: isActive,
					});
				}
			}
		}

		this._hoverGeometry(routeState.index);

		if (routeState.items.length && !CONFIG.inFrame) {
			this._interactive.start(routeState.responseData[routeState.index] ? routeState.responseData[routeState.index].totalLength : 0);
		}

		if (CONFIG.inFrame) {
			if (this._frameListenersSet) {
				this._geomLayer.removeEventListener("click", this);
				this._activeGeomLayer.removeEventListener("click", this);
				this._hoverGeomLayer.removeEventListener("click", this);
			}

			this._frameListenersSet = true;
			this._geomLayer.addEventListener("click", this);
			this._activeGeomLayer.addEventListener("click", this);
			this._hoverGeomLayer.addEventListener("click", this);
		}

		if (Scene.isM3dActive()) {
			this._m3d.show(this._showAlternatives ? this._interactive.allCoords : [this._interactive.allCoords[routeState.index]]);
		}
	}

	_activeMarkers(active) {
		for (let i = 0; i < this._markers.length; i++) {
			let m = this._markers[i];
			m.setDrag(active);
			m.setActive(active);
			m.setFocus(active);
		}

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.update({
				visual: active
					? "standard"
					: "inactive",
				draggable: active,
			});
		}

		if (active && !this._ss.length) {
			this._ss.push(Scene.addListener("marker-enter", "_markerEnter", this));
			this._ss.push(Scene.addListener("marker-leave", "_markerLeave", this));
		}
		else if (!active && this._ss.length) {
			Scene.removeListeners(this._ss);
			this._ss = [];
		}
	}

	_hoverGeometry(index) {
		let actualIndex = Mapy.CML.state.route.index;

		this._clearLayer(this._hoverGeomLayer);

		if (this._geometry[index]) {
			if (index == actualIndex) {
				this._clearLayer(this._activeGeomLayer);
			}

			for (let i = 0; i < this._geometry[index].length; i++) {
				let g = this._geometry[index][i];
				this._geomLayer.removeSmartGeometry(g);
				(index != actualIndex ? this._hoverGeomLayer : this._activeGeomLayer).addSmartGeometry(g);
				(index != actualIndex ? this._hoverGeomLayer : this._activeGeomLayer).redrawSmartGeometry(g);
			}

			if (this._trafficGeom[index]) {
				for (let i = 0; i < this._trafficGeom[index].length; i++) {
					let g = this._trafficGeom[index][i];
					this._geomLayer.removeGeometry(g);
					(index != actualIndex ? this._hoverGeomLayer : this._activeGeomLayer).addGeometry(g);
				}
			}

			this._summaryMarkers.hoverMarker(index);
		}

		for (let i = 0; i < this._closuresGeom.length; i++) {
			let cgs = this._closuresGeom[i];

			if (cgs) {
				for (let num = 0; num < cgs.length; num++) {
					let cg = cgs[num];
					if (index == i) {
						this._geomLayer.removeSmartGeometry(cg);
						(index != actualIndex ? this._hoverGeomLayer : this._activeGeomLayer).addSmartGeometry(cg);
						(index != actualIndex ? this._hoverGeomLayer : this._activeGeomLayer).redrawSmartGeometry(cg);
					}
				}
			}
		}

		for (let i = 0; i < this._points.length; i++) {
			let pts = this._points[i];

			if (pts && pts.length) {
				for (let num = 0; num < pts.length; num++) {
					let pt = pts[num];

					if (i == actualIndex) {
						this._pointLayer.addGeometry(pt);
					}
					else if (pt.sceneOwner == this._pointLayer) {
						this._pointLayer.removeGeometry(pt);
					}
				}
			}
		}


		/*this._geomLayer.redraw();
		this._activeGeomLayer.redraw();
		this._hoverGeomLayer.redraw();
		this._pointLayer.redraw();*/

	}

	_toggleClosureMarkers(removeAll) {
		if (this._closureMarkers.length) {
			for (let i = 0; i < this._closureMarkers.length; i++) {
				let cms = this._closureMarkers[i];

				if (cms.length) {
					for (let num = 0; num < cms.length; num++) {
						let cm = cms[num];
						const visible = Mapy.CML.state.route.index == i && !removeAll;

						this._closureLayer[(visible ? "add" : "remove") + "Marker"](cm.marker);
						cm.wasmMarker.update({
							visible,
						});
					}
				}
			}
		}
	}

	_clearGeometry(state) {
		let items = state.route.items;

		items.forEach(i => {
			i.path = [];
			i.pubtData = "";
		});

		this._makeGeometry(items, state);

		this._m3d.clear();

		this._interactive.enabled = false;
	}

	/**
	 * odebere z predane vrstvy geometrie a vrati do geomLayer vrstvy
	 * @param  {Layer} layer vrstva
	 */
	_clearLayer(layer) {
		for (let i = 0; i < this._geometry.length; i++) {
			let gs = this._geometry[i];

			for (let num = 0; num < gs.length; num++) {
				let g = gs[num];

				if (g.sceneOwner == layer) {
					layer.removeSmartGeometry(g);
					this._geomLayer.addSmartGeometry(g);
					this._geomLayer.redrawSmartGeometry(g);
				}
			}

			let tgs = this._trafficGeom[i];
			if (tgs) {
				for (let num = 0; num < tgs.length; num++) {
					let g = tgs[num];

					if (g.sceneOwner == layer) {
						layer.removeGeometry(g);
						this._geomLayer.addGeometry(g);
					}
				}
			}

			let cgs = this._closuresGeom[i];
			if (cgs) {
				for (let num = 0; num < cgs.length; num++) {
					let g = cgs[num];

					if (g.sceneOwner == layer) {
						layer.removeSmartGeometry(g);
						this._geomLayer.addSmartGeometry(g);
						this._geomLayer.redrawSmartGeometry(g);
					}
				}
			}

			let pts = this._points[i];
			if (pts) {
				for (let num = 0; num < pts.length; num++) {
					let p = pts[num];

					if (p.sceneOwner == layer) {
						layer.removeSmartGeometry(p);
						this._geomLayer.addGeometry(p);
					}
				}
			}
		}
	}

	_changeStyle(g, active, type) {
		let style = g.getOptions();
		let routeState = Mapy.CML.state.route;

		if (type == "closure") {
			if (active == ACTIVE) {
				g.setOptions(Object.assign(style, ROUTE_CONST.DEFAULT_LINE_STYLE, ROUTE_CONST.CLOSURE_LINE_COLOR));
			}
			else {
				g.setOptions(Object.assign(style, ROUTE_CONST.CAR_LINE_STYLE_MODIFY, ROUTE_CONST.DEACTIVE_LINE_COLOR));
			}
		}
		else if (type == "traffic") {
			//console.log(style);
			let newStyle = [];
			for (let i = 0; i < style.length; i++) {
				newStyle.push(Object.assign({}, style[i], ROUTE_CONST.TRAFFIC_LINE_COLOR[style[i].trafficType][active == ACTIVE ? "active" : "deactive"]));
			}

			g.setOptions(newStyle);
		}
		else {
			if (active == ACTIVE) {
				g.setOptions(Object.assign(style, ROUTE_CONST[routeState.params.type == ROUTE_CONST.TYPE_CAR ? "CAR_LINE_STYLE_MODIFY" : "DEFAULT_LINE_STYLE"], ROUTE_CONST.ACTIVE_LINE_COLOR));
			}
			else {
				g.setOptions(Object.assign(style, ROUTE_CONST.CAR_LINE_STYLE_MODIFY, ROUTE_CONST.DEACTIVE_LINE_COLOR));
			}
		}
	}

	_openOnMap() {
		Mapy.Util.openInNewWindow();
	}
}
